export default __webpack_public_path__ + "static/media/skills-matrix-template.f57c5564.png";